// extracted by mini-css-extract-plugin
module.exports = {"fontLato":"Lato, Menlo, Monaco, Consolas, \"Courier New\", monospace","addButton":"styles_addButton__1T85J","grey":"styles_grey__CCAcP","red":"styles_red__3D3tV"};